/** 
 * @type {StorageMediaFileFilter} 
 */
const filter = {
    names: null,
}
/** 
* @returns {StorageMediaFileFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/StorageMediaFileFilter.js